// routes/metadata.ts
interface RouteMetadata {
    [key: string]: {
      title: string;
      description: string;
      keywords?: string[];
    };
  }
  
  export const routeMetadata: RouteMetadata = {
    '/': {
      title: 'Home',
      description: 'Welcome to our trading platform',
      keywords: ['trading', 'forex', 'crypto']
    },
    '/login': {
      title: 'Login',
      description: 'Login to your account'
    },
    '/register': {
      title: 'Register',
      description: 'Create a new account'
    },
    '/trade': {
      title: 'Trade',
      description: 'Start trading on our platform',
      keywords: ['trade', 'forex', 'stocks']
    },
    '/p2p': {
      title: 'P2P Trading Platform',
      description: 'Buy and sell cryptocurrencies directly with other users on our secure P2P platform',
      keywords: ['p2p trading', 'crypto exchange', 'peer-to-peer'],
    },
    // Add metadata for all your routes
  };